<template lang="pug">
  div(
    style="display: block;"
  )
    div(
      style="display:flex; flex-direction: row; justify-content: space-between; align-items: center;"
    )
      span(
        style="flex-basis: 200px;"
      ) Виды деятельности:
      template(
        v-for="action in actions"
      )
        div.flex-wrap
          label.checked {{ action.label }}
          input(
            type="checkbox"
            v-model="value.actions"
            @change="onChange"
            :value="action.label"
          ).filter-checkbox
</template>

<script>
  import { ACTIONS } from '@/config/config'
  export default {
    name:  'actions-filter',
    props: { value: { type: Object, default: () => ({ actions: [] }) } },
    computed: { actions () { return Object.values(ACTIONS) } },
    methods: { onChange() { this.$emit('applyFilter') } }
  }
</script>

<style scoped lang="scss">
  .flex-wrap {
    display: inline-flex;
    -ms-flex-wrap: wrap;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    align-items: center;
  }
  .filter-checkbox {
    width: 17px!important;
    height: 17px;
  }
  input {
    padding: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #ddd;
    border-radius: 4px;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    height: 36px;
    font-size: 14px;
    font-family: "SFUIText-Regular";
    color: #19233c;
  }
</style>